import React, { useState, useEffect } from "react";
import RBPageCotainer from "./RBPageContainer";
import RbBlogFilter from "./RbBlogFilter";
import RbAllBlogs from "./RbAllBlogs";
import BlogRequests from "../../assets/services/blog";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../assets/containers/loadingDialog";
import { useLocation } from "react-router-dom";
import { clearRbBlogs } from "../../assets/redux/actions/Blog";

const RBBlog = () => {
  const [selctedFilter, setSelctedFilter] = useState("RaheBehesht1403");
  const { fetchBlogsLoading } = useSelector(({ blog }) => blog);
  // const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let query = queryParams.get("search");

  useEffect(() => {
    dispatch(clearRbBlogs());
    if (query) {
      setSelctedFilter(query);
    }
  }, [query]);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(clearRbBlogs());
        await dispatch(BlogRequests.getBlogsByTag(selctedFilter, 1));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [selctedFilter, query, dispatch]);

  const handleSelectFilter = (selected) => {
    setSelctedFilter(selected);
  };

  return (
    <RBPageCotainer>
      <div className="px-3">
        <RbBlogFilter
          query={query}
          selected={selctedFilter}
          handleSelect={(selected) => handleSelectFilter(selected)}
        />
        {fetchBlogsLoading ? (
          <Loading
            className={"w-100 d-flex justify-content-center my-5 py-5"}
            dark={true}
          />
        ) : (
          <RbAllBlogs bLogFilter={selctedFilter} />
        )}
      </div>
    </RBPageCotainer>
  );
};

export default RBBlog;
